var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-tag",class:_vm.classes},[(_vm.htmlUrl)?_c('html-link',{attrs:{"url":_vm.htmlUrl}},[_vm._v("\n        "+_vm._s(_vm.name)+"\n    ")]):_c('div',[_vm._v("\n        "+_vm._s(_vm.name)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }